import Payment from "../../slices/payments/payment/Payment"
import Charges from "../../slices/payments/charges/Charges"

const paymentsReducer = {
    payment: Payment,
    charges: Charges,
};

export default paymentsReducer;
